var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { gql, useMutation } from '@apollo/client';
const LOGOUT = gql `
  mutation {
    signOut {
      success
    }
  }
`;
const useCronoLogout = () => {
    const [signout] = useMutation(LOGOUT);
    const ssoUri = () => {
        if (process.env.REACT_APP_URI_ENV === 'prod') {
            return 'https://sso.matchplat.com/';
        }
        else if (process.env.REACT_APP_URI_ENV === 'test') {
            return 'https://sso-test.matchplat.com/';
        }
        else {
            return 'https://sso-test.matchplat.com/';
        }
    };
    const logout = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield signout();
            const logoutURL = ssoUri();
            return window.location.replace(logoutURL);
        }
        catch (e) {
            console.error('error on signout: ' + e);
        }
    });
    return { logout };
};
export default useCronoLogout;
